import axios from "axios";
import {getUserToken} from "../../../../../utils/functions/userToken";
import {APP_KAYAK_BIDDING_API_ENDPOINT} from "../../../../../constants/api_urls";
import {apiUrlActiveMultipliers} from "./apiUrlMultipliers";

export const getFilters = async (id_account) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.get(
            `${APP_KAYAK_BIDDING_API_ENDPOINT}/api/kayak/active-bidding-filters/${id_account}/`,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.errorMessage || "Failed to fetch campaign details";
        return { success: false, error: errorMessage };
    }
};

export const getBiddingDetails = async (id_account, multipliers) => {
    const jwtToken = getUserToken();

    try {
        const response = await axios.get(
            `${apiUrlActiveMultipliers['get'][multipliers]}${id_account}/`,
            {
                headers: {
                    Authorization: `Bearer ${jwtToken}`,
                    "Content-Type": "application/json",
                },
            }
        );
        return { success: true, data: response.data };
    } catch (error) {
        const errorMessage =
            error?.response?.data?.errorMessage || "Failed to fetch campaign details";
        return { success: false, error: errorMessage };
    }
};
